import { useNavigate } from 'react-router-dom'
import { useCallback, useEffect, useState } from 'react'

import styles from './styles.module.scss'

import { useCurso } from '@/hooks/useCurso'
import { InstitutionRepository } from '@/pages/admin/repositories/institution.repository'
import { CursoRepository } from '@/pages/admin/repositories/curso.repository'

interface InstitutionCourse {
  id: number
  titulo: string
  title: string
}

interface IProps {
  category: string
  setCategory: (category: string) => void
}

export const SearchCourse = ({ category, setCategory }: IProps) => {
  const schoolCategories = ['2', '5', '8', '9']

  const navigate = useNavigate()
  const [city, setCity] = useState('')
  const [bairro, setBairro] = useState('')
  const { pesquisa, selectTitulo } = useCurso()
  const [cities, setCities] = useState<string[]>([])
  const [loading, setLoading] = useState(false)
  const [neighborhoods, setNeighborhoods] = useState<string[]>([])
  const [institutionsCourse, setInstitutionsCourses] = useState<any[]>([])
  const [institutions, setInstitutions] = useState<InstitutionCourse[]>([])
  const [tipoSelected, setTipoSelected] = useState<'INST' | 'CURSO'>('INST')
  const [selectedInstitution, setSelectedInstitution] = useState<string>('-1')

  const fetchCities = useCallback(async () => {
    setCities([])
    const _cities =
      await InstitutionRepository.GetInstance().listCities(category)
    setCities((current) => [...current, ..._cities])
  }, [])

  useEffect(() => {
    fetchCities()
  }, [])

  const isEscola = (): boolean => schoolCategories.includes(category)

  async function fetchNeighborhoods(category_id: string, city: string) {
    setNeighborhoods([])
    setInstitutionsCourses([])
    const neighborhoods =
      await InstitutionRepository.GetInstance().listNeighborhoods(
        category_id,
        city,
      )
    setNeighborhoods(neighborhoods || [])
  }

  function handleBuscar() {
    if (tipoSelected == 'CURSO') {
      if (!category || !city || !bairro || !pesquisa.titulo) return
      navigate(
        `/cursos/${category}/${city.replaceAll(' ', '-')}/${bairro}/${
          pesquisa.titulo
        }`,
      )
    } else {
      const institution = institutions.find(
        (i) => i.id.toString() == selectedInstitution,
      )
      if (!selectedInstitution || !institution) return
      navigate(
        `/cursos/${institution.title.replaceAll(
          ' ',
          '-',
        )}/${selectedInstitution}/${category}`,
      )
    }
  }

  async function fetchInstitutions(
    category_id: string,
    cidade: string,
    bairro: string,
  ) {
    setLoading(true)
    const institutionList =
      await InstitutionRepository.GetInstance().listInstitutions(
        Number(category_id),
        cidade,
        bairro,
      )
    setInstitutions(institutionList.institutions)
    setLoading(false)
  }

  async function fetchInstitutionsCourses(
    category_id: string,
    city: string,
    neighborhood: string,
  ) {
    setInstitutionsCourses([])
    if (tipoSelected == 'INST') {
      await fetchInstitutions(category_id, city, neighborhood)
      return
    }

    if (!category || !city) return

    setLoading(true)

    const institutions =
      await CursoRepository.GetInstance().listInstitutionsWithParameters(
        Number(category_id),
        city,
        neighborhood,
      )
    const institutionMapped = institutions?.map((t) => t.titulo) || []
    setInstitutionsCourses([])
    setInstitutionsCourses((current) => [...current, ...institutionMapped])
    selectTitulo(institutionMapped[0])
    setLoading(false)
  }

  return (
    <div className={styles.container}>
      <div className={styles.inputs}>
        <div className={styles.align}>
          <input
            onClick={async () => {
              setTipoSelected('INST')
              await fetchInstitutionsCourses(category, city, bairro)
            }}
            name="tipo"
            type="radio"
            defaultChecked={tipoSelected == 'INST'}
          />
          <p>{isEscola() ? 'Escola' : 'Instituição'}</p>
        </div>

        <div className={styles.align}>
          <input
            onClick={async () => {
              setTipoSelected('CURSO')
              await fetchInstitutionsCourses(category, city, bairro)
            }}
            name="tipo"
            type="radio"
            defaultChecked={tipoSelected == 'CURSO'}
          />
          <p>{isEscola() ? 'Série' : 'Curso'}</p>
        </div>
      </div>

      <div className={styles.filter}>
        <div className={styles.column}>
          <p>O que deseja estudar?</p>
          <select
            value={category}
            onChange={(e) => setCategory(e.target.value)}
          >
            <option value={'2'}>Ensino Básico</option>
          </select>
        </div>

        <div className={styles.column}>
          <p>Escolha uma cidade:</p>
          <select
            value={city}
            onChange={async (e) => {
              setCity(e.target.value)
              await fetchNeighborhoods(category, e.target.value)
            }}
          >
            <option>Escolha a cidade...</option>
            {cities
              ?.sort((a, b) => (a > b ? 1 : -1))
              ?.map((c) => (
                <option>{c}</option>
              ))}
          </select>
        </div>

        <div className={styles.column}>
          <p>Escolha um bairro:</p>
          <select
            onChange={async (e) => {
              setBairro(e.target.value)
              await fetchInstitutionsCourses(category, city, e.target.value)
            }}
          >
            <option>Escolha o bairro...</option>
            {neighborhoods
              ?.sort((a, b) => (a > b ? 1 : -1))
              ?.map((c) => (
                <option>{c}</option>
              ))}
          </select>
        </div>
        <div className={styles.column}>
          {tipoSelected == 'CURSO' ? (
            <p>{isEscola() ? 'Escolha uma série:' : 'Escolha um curso: '}</p>
          ) : (
            <p>
              {isEscola() ? 'Escolha uma escola:' : 'Escolha uma instituição: '}
            </p>
          )}

          {tipoSelected == 'CURSO' ? (
            <select onChange={(e) => selectTitulo(e.target.value)}>
              <option>
                {isEscola() ? 'Escolha uma série... ' : 'Escolha um curso... '}
              </option>
              {institutionsCourse.length > 0 &&
                institutionsCourse.map((t) => <option>{t}</option>)}
              {institutionsCourse.length === 0 && (
                <option value="none">Nada encontrado...</option>
              )}
            </select>
          ) : (
            <select onChange={(e) => setSelectedInstitution(e.target.value)}>
              <option>
                {isEscola()
                  ? 'Escolha uma escola... '
                  : 'Escolha uma instituição... '}
              </option>

              {!loading &&
                institutions.length > 0 &&
                institutions?.map((t) => (
                  <option value={t.id}>{t.title}</option>
                ))}
              {!loading && institutions.length === 0 && (
                <option value="none">Nada encontrado...</option>
              )}
              {loading && <option value="none">Carregando...</option>}
            </select>
          )}
        </div>
      </div>
      <div>
        <button onClick={handleBuscar} className={styles.button}>
          SELECIONAR
        </button>
      </div>
    </div>
  )
}
